import { useCreateFlexibleReportRequestMutation } from '@features/flexible-reports';
import { START_DATE_CUTOFF_IN_MONTHS } from '../../../../../flexible-reports/domain/dates';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type NewReportButtonProps = {
  campaignId: number;
  disabled: boolean;
};

export const NewReportButton = (props: NewReportButtonProps) => {
  const { campaignId } = props;
  const navigate = useNavigate();
  const [createFlexibleReportRequest] =
    useCreateFlexibleReportRequestMutation();

  const onClick = useCallback(async () => {
    const id = await createFlexibleReportRequest({ campaignId }).unwrap();
    void navigate(`/campaigns/v3/${campaignId}/flexible-report-requests/${id}`);
  }, [campaignId, createFlexibleReportRequest, navigate]);

  return (
    <Tooltip
      title={
        props.disabled
          ? `Campaigns with an end date older than ${START_DATE_CUTOFF_IN_MONTHS} months cannot generate new flexible reports`
          : ''
      }
    >
      <span>
        <Button
          startIcon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => void onClick()}
          disabled={props.disabled}
        >
          New Report
        </Button>
      </span>
    </Tooltip>
  );
};
